import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-logged',
	templateUrl: './logged.component.html',
	standalone: true,
})
export class LoggedComponent {
	private readonly router = inject(Router);

	constructor() {
		this.getRedirection();
	}

	private getRedirection(): void {
		const redirectUrl = sessionStorage.getItem('redirect_url');
		const searchParams = sessionStorage.getItem('search_params');
		if (redirectUrl) {
			sessionStorage.removeItem('redirect_url');
			sessionStorage.removeItem('search_params');
			this.router.navigate([redirectUrl], {
				queryParams: searchParams ? JSON.parse(searchParams) : null,
			});
		} else {
			this.router.navigate(['home']);
		}
	}
}
